export default "__VITE_ASSET__BfW8HlVw__"